import { CodeSystem } from "@intocare/datatypes/lib/code-system";

export const OBSERVATION_CONTEXT_ABSENT_REASON = {
	name: "OBSERVATION_CONTEXT_ABSENT_REASON",
	concept: {
		UNKNOWN: {
			display: {
				"nl-BE": "Context onbekend",
				"fr-BE": "Contexte inconnu",
			},
		},
	},
} as const satisfies CodeSystem;
